var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5c.825 0 1.5.675 1.5 1.5S6.825 4.5 6 4.5 4.5 3.825 4.5 3 5.175 1.5 6 1.5zM6 9c2.025 0 4.35.967 4.5 1.5h-9C1.673 9.96 3.982 9 6 9zm0-9a3 3 0 100 6 3 3 0 100-6zm0 7.5c-2.002 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z",
    fill: "#CACACA"
  })));
}
export default SvgPassenger;